import { connect } from 'react-redux'
import { sagaActions } from 'store/sagas'
import unreadNotificationsSelector from './unreadNotificationsSelector'
import {
  setUnreadOnly as setNotificationsUnreadOnly
} from 'store/redux/notifications'
import UnreadNotifications from './UnreadNotifications'

export default connect(
  unreadNotificationsSelector,
  {
    fetchActivities: sagaActions.fetchNotifications,
    requestMarkAllNotificationsAsRead: sagaActions.requestMarkAllNotificationsAsRead,
    setNotificationsUnreadOnly
  }
)(UnreadNotifications)
